import { myReceivers } from '@/assets/js/eventAnalyze.config.js'
export function myReceiversAnalyze (str, path) {
  if (path != '/mr') return
  try {
    // 防止未加载ga
    gtag('event', myReceivers[str]) // 谷歌统计
  } catch (err) {}
}
